import { t } from '@core/i18n';

export enum LettingTransactionTypes {
  NEW_LEASE = 0,
  RESTRUCTURE = 1,
  RENEWAL = 2,
  RENT_REVIEW = 3,
  ASSIGNMENT = 4,
  SUB_LETTING = 5,
  LICENSE = 6,
  REGEAR = 7,
}

// TODO: needs to be moved to backend
export const getLettingTransactionTypeLabels = () => ({
  [LettingTransactionTypes.NEW_LEASE]: t('new_lease'),
  [LettingTransactionTypes.RESTRUCTURE]: t('restructure'),
  [LettingTransactionTypes.RENEWAL]: t('renewal'),
  [LettingTransactionTypes.RENT_REVIEW]: t('rent_review'),
  [LettingTransactionTypes.ASSIGNMENT]: t('assignment'),
  [LettingTransactionTypes.SUB_LETTING]: t('subletting'),
  [LettingTransactionTypes.LICENSE]: t('licence'),
  [LettingTransactionTypes.REGEAR]: t('regear'),
});

export interface ITransactionLetting {
  address: string;
  buildingTypes: string[];
  buildingTypesString: string;
  capital_incentives: string;
  confidential: boolean;
  created_at: string;
  demise: string;
  entire_property: boolean;
  fitout_condition: string;
  fitout_concept: string;
  has_lease_expired: boolean;
  id: Id;
  image: string | null;
  landlord: string;
  landlord_represented_by: string;
  landlords_agent_string: string;
  landlords_string: string;
  lat: number | null;
  lease_end: string | null;
  lease_expired: string;
  lease_expiry_comments: string | null;
  lease_expiry_reason: null;
  lease_expiry_reason_string: null;
  lease_length: string;
  lease_length_string: string | null;
  lease_start: string | null;
  lng: number | null;
  next_lease_event: string | null;
  notice_months: null;
  postcode: string;
  reason_for_requirement_string: string;
  rent_free_dates: string[];
  rent_free_string: string;
  rent_metric: Metric | null;
  rent_pa: string;
  rent_psf: string;
  rent_value: string;
  rolling: boolean;
  sectors_string: string;
  signature_date: string | null;
  size: string;
  source_readable: string | null;
  tenant: string;
  tenant_represented_by: string;
  tenants_agent_string: string;
  town: string;
  transaction_status: number;
  transaction_status_string: string;
  type: string;
  units: string;
  units_string: string;
  updated_at: string;
}

// Mirrors the keys of App\Services\Transactions\Fields\LettingTransactionFields; keep both in step.
export type LettingTransactionFieldKey =
  | 'building_types'
  | 'landlord_agent_users'
  | 'landlord_companies'
  | 'landlord_contacts'
  | 'lease_end'
  | 'lease_length'
  | 'lease_start'
  | 'our_instructions'
  | 'rent'
  | 'signature_date'
  | 'size'
  | 'tenant_agent_users'
  | 'tenant_companies'
  | 'tenant_contacts'
  | 'type';
